import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

type DeleteNotificationRulesParams = {
  notification_rule_ids: string[];
};

export function useDeleteNotificationRules({
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, DeleteNotificationRulesParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ notification_rule_ids }) => {
      await client.delete(`/apps/${applicationID}/notification_rules`, {
        params: { 'notification_rule_ids[]': notification_rule_ids },
      });
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['notification-rules']);
      },
    }
  );
}
